import { Box, Typography, Grid, Divider, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Parameters from "../Components/Parameters";
import { useLocation } from "react-router-dom";
import { useEffect, useContext } from "react";
import { RegionContext } from "../RegionContext";
import { Helmet } from "react-helmet";

const emails = {
  sg: "support@paymate.sg",
  my: "support@paymate.my",
  au: "support@dunomo.au",
  ae: "support@paymate.ae",
  om: "support@paymate.om",
  za: "support@dunomo.za",
};

export default function IntroductionPage(props) {
  const location = useLocation();
  const { data, setData } = useContext(RegionContext);

  useEffect(() => {
    if (location.pathname === "/" && location.hash !== "") {
      const id = location.hash.split("#")[1];

      if (id === "overview") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  });

  return (
    <>
      <Helmet>
        <title>
          {data.region === "au"
            ? "Dunomo Partner APIs"
            : "PayMate Partner APIs" || ""}
        </title>
      </Helmet>
      <Box className="introduction-page">
        <Grid container spacing={0}>
          <Grid item xs={12} md={9} sm={12} lg={9}>
            <Box className="introduction-page-left">
              <Box id="overview">
                <Typography id="intro-title-label">Overview</Typography>

                <Typography variant="subtitle2" id="intro-title-para">
                  Explore the full range of offerings and comprehensive suite of
                  products available within{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  platform.
                </Typography>
              </Box>

              <Divider className="divider" />

              <Box id="purpose">
                <Typography id="intro-title-label">Purpose</Typography>

                <Typography variant="subtitle2" id="intro-title-para">
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  API allows any business to integrate with{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"} to
                  process their business payments seamlessly over a RESTful HTTP
                  interface. The API will let businesses add their vendors and
                  customers, make vendor payments, collect payments from
                  customers, track payments and much more.{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  API will help you streamline your business payments processes
                  right from within your existing systems.
                </Typography>
                <br />
                <Typography id="intro-title-sub-label">
                  Simplify Global Business to Business Payments
                </Typography>

                <Typography variant="subtitle2" id="intro-title-para">
                  With{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  business payments solution, you can now make b2b payments,
                  collect payments from your customers and perform payment
                  reconciliations with a powerful and scalable payments
                  platform, that can be tailor made as per your business needs.
                </Typography>
                <br />
                <Typography id="intro-title-sub-label">
                  What{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  offers
                </Typography>

                <ul>
                  <li>
                    <Typography variant="subtitle2" id="intro-title-para">
                      <b>Make your Business Payments</b>:{" "}
                      {["au", "za"].includes(data.region)
                        ? "DuNoMo"
                        : "PayMate"}{" "}
                      business platform is built to handle the payments
                      requirements of your business. Whether you want to
                      integrate and make payments or perform the multi-level
                      approvals or grouping multiple payments together,{" "}
                      {["au", "za"].includes(data.region)
                        ? "DuNoMo"
                        : "PayMate"}{" "}
                      is your one stop solution for all business payments.{" "}
                    </Typography>
                  </li>

                  <li>
                    <Typography variant="subtitle2" id="intro-title-para">
                      <b>Collect Payments</b>: With{" "}
                      {["au", "za"].includes(data.region)
                        ? "DuNoMo"
                        : "PayMate"}{" "}
                      you can effortlessly create and send payment collection
                      requests to your customers. These requests can be sent on
                      emails, WhatsApp or SMS and allow you to collect payments
                      directly into your desired bank account.
                    </Typography>
                  </li>

                  <li>
                    <Typography variant="subtitle2" id="intro-title-para">
                      <b>Recurring payment collections</b>: Automate recurring
                      payment collections from your customers or tenants against
                      properties leased out. These collections can be configured
                      for periodic time periods.{" "}
                    </Typography>
                  </li>

                  <li>
                    <Typography variant="subtitle2" id="intro-title-para">
                      <b>Verify KYC/KYB</b>:{" "}
                      {["au", "za"].includes(data.region)
                        ? "DuNoMo"
                        : "PayMate"}{" "}
                      performs soft KYB/KYC of your suppliers or customers to
                      verify their account, business details, AML checks to
                      ensure compliance before initiating payouts.{" "}
                    </Typography>
                  </li>
                </ul>
              </Box>

              <Divider className="divider" />

              {/* <Box id="intro-requirement">
              <Typography id="intro-title-label">Requirement</Typography>

              <Typography variant="subtitle2" id="intro-title-para">
                Before any business can start using the PayMate API platform to
                process their business payments, the business needs to
              </Typography>

              <ul>
                <li>
                  <Typography variant="subtitle2" id="intro-title-para">
                    <a target="_blank" href="https://paymate.in/Signup.aspx">
                      Signup
                    </a>{" "}
                    ​on PayMate
                  </Typography>
                </li>
                <li>
                  <Typography variant="subtitle2" id="intro-title-para">
                    Complete KYC Verification
                  </Typography>
                </li>
                <li>
                  <Typography variant="subtitle2" id="intro-title-para">
                    Upgrade to any one of the subscription plans which provides
                    API access.{" "}
                    <a target="_blank" href="https://paymate.in/pricing.html">
                      ​Click here
                    </a>
                    ​ to check out the pricing plans
                  </Typography>
                </li>
                <li>
                  <Typography variant="subtitle2" id="intro-title-para">
                    Whitelist the domain name or IP address from where the API
                    will be accessed
                  </Typography>
                </li>
              </ul>

              <Typography variant="subtitle2" id="intro-title-para">
                Once the business upgrades to a paid plan the API settings will
                be accessible under <b>​Account Settings - API Settings</b>​.
                The API Settings will have details about the authentication and
                encryption keys to be used when accessing the APIs. The
                authentication keys consist of
              </Typography>

              <ul>
                <li>
                  <Typography variant="subtitle2" id="intro-title-para">
                    32 digit alphanumeric MerchantIdentification
                  </Typography>
                </li>
                <li>
                  <Typography variant="subtitle2" id="intro-title-para">
                    32 digit alphanumeric TerminalIdentification
                  </Typography>
                </li>
                <li>
                  <Typography variant="subtitle2" id="intro-title-para">
                    10 digit alphanumeric XpressID
                  </Typography>
                </li>
                <li>
                  <Typography variant="subtitle2" id="intro-title-para">
                    Email address which was used during signup
                  </Typography>
                </li>
                <li>
                  <Typography variant="subtitle2" id="intro-title-para">
                    AES KEY & IV for encrypting/decrypting JSON data in API
                    request/response parameters.
                  </Typography>
                </li>
              </ul>

              <Box id="note">
                <InfoIcon />
                <Typography variant="subtitle2" id="note-para">
                  The AES encryption key and IV can be changed anytime due to
                  security reasons.
                </Typography>
              </Box>
            </Box> */}

              <Box id="introduction">
                <Typography id="intro-title-label">Introduction</Typography>

                <Typography variant="subtitle2" id="intro-title-para">
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  provides Payment Service Provider solutions to businesses.
                  Using{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  platform, businesses can make and collect their business
                  payments using Credit Card. You can also schedule payments or
                  set up auto payments for auto debit on your commercial credit
                  card.
                </Typography>

                <br />

                <Typography variant="subtitle2" id="intro-title-para">
                  Our dashboard provides you with an overview on your business
                  payments and helps you effectively manage and monitor your
                  business account. You can view detailed transactions, get
                  accurate transaction statuses, send payment links to your
                  customers without any payment gateway integrations. You can
                  also easily automate your payment flows using our APIs.
                </Typography>

                <br />

                <Typography variant="subtitle2" id="intro-title-para">
                  The user management on your business account will allow you to
                  have users from multiple departments with specific user role
                  access. With{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"},
                  you also get access to features like custom approval
                  workflows, approve and process multiple payments on a single
                  card charge transaction for easier reconciliation and many
                  others.
                </Typography>
              </Box>

              <Divider className="divider" />

              <Box id="api-development">
                <Typography id="intro-title-label">
                  API Development Environment
                </Typography>

                <Typography variant="subtitle2" id="intro-title-para">
                  For quick and seamless API integration every registered
                  business on{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  will have access to the Development environment of the API
                  platform. The Development environment will help businesses to
                  develop, integrate and test the existing and new API methods
                  before moving to production.
                </Typography>
                {/* <br />
              <Typography variant="subtitle2" id="intro-title-para">
                The Development environment is a simulated environment i.e all
                the API methods have predefined request parameters and response
                parameters. You will not be able to add/delete any records using
                the API methods on the Development environment. Rest assured the
                API methods on the Development environment works exactly the
                same way as on a Production environment.
              </Typography>
              <br />
              <Typography variant="subtitle2" id="intro-title-para">
                Here are the details for the Development environment.
              </Typography>

              <Box id="api-url-box">
                <Typography id="api-link" sx={{ flex: 1 }}>
                  {`https://uat.paymate.co.in/PayMateSite/PayMateService/PMXClients.svc/PMXClients/<method name>`}
                  ​
                </Typography>

                <IconButton
                  onClick={() =>
                    props.copyClipBoard(
                      `https://uat.paymate.co.in/PayMateSite/PayMateService/PMXClients.svc/PMXClients/<method name>`
                    )
                  }
                  aria-label="delete"
                  size="small"
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Box>

              <Box>
                <Parameters data={table_data} />
              </Box>

              <Box sx={{ mt: 3 }}>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Encryption keys
                </Typography>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  <code>AES Key: C1845346D7562D7DC15695B63DD49A63</code>
                </Typography>
                <Typography variant="subtitle2">
                  ​<code>AES IV: 63D11193F56FE438</code>
                </Typography>
              </Box> */}
              </Box>

              <Divider className="divider" />

              <Box id="authentication">
                <Typography id="intro-title-label">Authentication</Typography>

                <Typography variant="subtitle2" id="intro-title-para">
                  The{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  API uses secret API Key to authenticate requests.
                  Partner/Merchant will get their secret API Keys after
                  successful onboarding by writing to us at{" "}
                  <a href={`mailto:${emails[data.region]}`}>
                    {emails[data.region]}
                  </a>
                </Typography>
              </Box>

              <Divider className="divider" />

              <Box id="data-security">
                <Typography id="intro-title-label">Data Security</Typography>

                <Typography variant="subtitle2" id="intro-title-para">
                  As customer will communicate with partner system over API,
                  customer data will be travel over internet and it needs to be
                  encrypted before being send over internet.
                </Typography>
                <br />
                <Typography variant="subtitle2" id="intro-title-para">
                  The{" "}
                  {["au", "za"].includes(data.region) ? "DuNoMo" : "PayMate"}{" "}
                  system will use hybrid encryption and decryption methodology.
                  Hybrid encryption is the combination of symmetric and
                  asymmetric encryption and allows us to encrypt the customer
                  data efficiently while ensuring secrecy is not compromised.
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
